/**
 * Shared RBAC submodule-permission helpers — the single source of truth for
 * "can this user see submodule X", used by BOTH the route guard
 * (<RequireSubmodule>) and the sidebar nav filter so they never drift.
 *
 * A submodule key is `module.submodule` (e.g. 'admin.rbac', 'attendance.fmla'),
 * matching the backend registry. The backend gate RequireSubmodule('module.sub')
 * checks `module.sub.view` on reads / `.edit` on writes, so page-view access is
 * governed by the `.view` key — which is exactly what these helpers check.
 */

export const viewKey = (submodule) => `${submodule}.view`;
export const editKey = (submodule) => `${submodule}.edit`;

/**
 * Does the user hold `permKey` (a full `module.sub.view|edit` key)?
 * Only is_super_admin bypasses — no role-name shortcuts.
 */
export function hasPermission(permKey, { permissions = [], isSuperAdmin = false } = {}) {
  if (isSuperAdmin) return true;
  return (permissions || []).includes(permKey);
}

/**
 * Can the user VIEW `submodule` (base `module.sub` key)? Delegates to
 * hasPermission on the `.view` key. This is the check both the route guard and
 * the navbar use.
*/
export function canViewSubmodule(submodule, ctx = {}) {
  if (!submodule) return true; // ungated item
  return hasPermission(viewKey(submodule), ctx);
}
